import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "chip-editor" }
const _hoisted_2 = { class: "chip-editor-h" }
const _hoisted_3 = { class: "chip-editor-count" }
const _hoisted_4 = {
  key: 0,
  class: "chip-editor-hint"
}
const _hoisted_5 = {
  class: "btn",
  "aria-label": "Add email"
}
const _hoisted_6 = { class: "tag-chip" }
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = {
  key: 0,
  class: "chip-editor-item-opts"
}
const _hoisted_9 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.label), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.modelValue.length), 1)
    ]),
    (_ctx.hint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.hint), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      class: "chip-editor-add",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.add()), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
        placeholder: "Add email..."
      }, null, 512), [
        [_vModelText, _ctx.input]
      ]),
      _createElementVNode("button", _hoisted_5, [
        _createVNode(_component_svg_icon, { icon: "plus" })
      ])
    ], 32),
    (_ctx.modelValue.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(['rcp-list', { 'rcp-list-locs': _ctx.showLocations }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (em, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "rcp-item"
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createTextVNode(_toDisplayString(em.email) + " ", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "tag-chip-x",
                  "aria-label": 'Remove ' + em.email,
                  title: "Remove",
                  onClick: ($event: any) => (_ctx.remove(i))
                }, [
                  _createVNode(_component_svg_icon, { icon: "x" })
                ], 8, _hoisted_7)
              ]),
              (_ctx.showLocations)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.locations, (loc, j) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: 'l'+j,
                        class: "checkbox-input"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((em.locations[loc]) = $event)
                        }, null, 8, _hoisted_9), [
                          [_vModelCheckbox, em.locations[loc]]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(loc), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}